import { FaInstagram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa";

const Socials = () => {
  return (
    <div className="socials">
      <a href="https://www.instagram.com/farejandopromos" target="_blank" rel="noreferrer">
        <FaInstagram className="social-icon" color="#FFF" />
      </a>
      <a href="https://www.tiktok.com/@farejando.promo" target="_blank" rel="noreferrer">
        <FaTiktok className="social-icon" color="#FFF" />
      </a>
      <a href="https://www.twitter.com/farejando.promo" target="_blank" rel="noreferrer">
        <FaXTwitter className="social-icon" color="#FFF" />
      </a>
      <a href="https://www.youtube.com/@Farejandopromos" target="_blank" rel="noreferrer">
        <FaYoutube className="social-icon" color="#FFF" />
      </a>
    </div>
  );
};

export default Socials;